import { h } from 'preact';
import { useState } from 'preact/hooks';
import { Toggle } from '../Toggle';
import type { ComponentShowcase } from '../registry';

function ToggleShowcaseWrapper() {
  const [val, setVal] = useState(true);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <Toggle label="Notificações" value={val} onChange={setVal} description="Receber alertas por email" />
      <Toggle label="Modo escuro" value={true} onChange={() => {}} />
      <Toggle label="Desabilitado" value={false} onChange={() => {}} disabled={true} />
      <Toggle label="Tamanho pequeno" value={true} onChange={() => {}} size="sm" />
    </div>
  );
}

export const showcase: ComponentShowcase = {
  name: 'Toggle',
  category: '📝 Formulários',
  description: 'Toggle on/off com label, descrição, tamanho sm e estado disabled',
  usedIn: ['Profile', 'AgentesPage', 'Integrations'],
  example: () => <ToggleShowcaseWrapper />,
};
